// Company Info
export const companyInfo = {
  email: 'info@lamazigrup.com',
  phone: '+48 888 500 885',
  whatsapp: '48888500885',
  instagram: 'lamazigrup'
};

// Images
export const images = {
  logo: 'https://customer-assets.emergentagent.com/job_fresh-produce-33/artifacts/1bifusfi_Lamazi.png',
  hero: {
    main: 'https://images.pexels.com/photos/1300975/pexels-photo-1300975.jpeg',
    secondary: 'https://images.pexels.com/photos/868110/pexels-photo-868110.jpeg'
  },
  logistics: [
    'https://images.pexels.com/photos/6169030/pexels-photo-6169030.jpeg',
    'https://images.pexels.com/photos/4483609/pexels-photo-4483609.jpeg',
    'https://images.pexels.com/photos/5953713/pexels-photo-5953713.jpeg',
    'https://images.pexels.com/photos/4487365/pexels-photo-4487365.jpeg'
  ],
  instagram: [
    { id: 1, image: 'https://customer-assets.emergentagent.com/job_fresh-produce-33/artifacts/dl1t2qqr_4.png', url: 'https://instagram.com/lamazigrup' },
    { id: 2, image: 'https://customer-assets.emergentagent.com/job_fresh-produce-33/artifacts/s9escezg_5.png', url: 'https://instagram.com/lamazigrup' },
    { id: 3, image: 'https://customer-assets.emergentagent.com/job_fresh-produce-33/artifacts/9o39u7s7_6.png', url: 'https://instagram.com/lamazigrup' },
    { id: 4, image: 'https://customer-assets.emergentagent.com/job_fresh-produce-33/artifacts/bjpodojz_1.png', url: 'https://instagram.com/lamazigrup' },
    { id: 5, image: 'https://customer-assets.emergentagent.com/job_fresh-produce-33/artifacts/6mnssyye_2.png', url: 'https://instagram.com/lamazigrup' },
    { id: 6, image: 'https://customer-assets.emergentagent.com/job_fresh-produce-33/artifacts/zjyga0vw_3.png', url: 'https://instagram.com/lamazigrup' }
  ]
};

// Bilingual content for Lamazi Group
export const content = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About',
      products: 'Products',
      packaging: 'Packaging',
      logistics: 'Logistics',
      contact: 'Contact',
      whatsapp: 'WhatsApp'
    },
    // Hero Section
    hero: {
      headline: 'Export-grade fresh produce, delivered with confidence.',
      subheadline: 'Lamazi Group supplies premium fruits and vegetables from Turkey to buyers across Europe—quality control, flexible packaging, and cold-chain logistics.',
      cta1: 'Request a Quote',
      cta2: 'View Products'
    },
    // Why Lamazi
    why: {
      title: 'Why Lamazi Group',
      subtitle: 'Export Excellence Since Day One',
      features: [
        {
          title: 'Quality Control',
          description: 'Rigorous inspection at every stage—from field to final packaging—ensuring only export-grade produce reaches your buyers.'
        },
        {
          title: 'Cold Chain Integrity',
          description: 'Advanced temperature-controlled logistics preserve freshness from Turkey farms to European warehouses.'
        },
        {
          title: 'Reliable Supply',
          description: 'Year-round availability with flexible volumes—meeting seasonal demand and long-term contracts with confidence.'
        },
        {
          title: 'Custom Packaging',
          description: 'Tailored packaging solutions with your branding—from bulk crates to retail-ready formats.'
        }
      ]
    },
    // Products
    products: {
      title: 'Premium Fresh Produce',
      subtitle: 'Export-Grade Quality from Turkey',
      categories: [
        {
          name: 'Tomatoes',
          description: 'Vine-ripened, firm varieties ideal for retail and food service. Available year-round.',
          image: 'https://images.pexels.com/photos/1327838/pexels-photo-1327838.jpeg',
          seasonality: 'Year-round'
        },
        {
          name: 'Cucumbers',
          description: 'Crisp, fresh cucumbers perfect for retail distribution. Greenhouse and field varieties.',
          image: 'https://images.unsplash.com/photo-1587411768638-ec71f8e33b78',
          seasonality: 'Year-round'
        },
        {
          name: 'Peppers',
          description: 'Colorful, sweet peppers in red, yellow, and green. Premium quality for European markets.',
          image: 'https://images.pexels.com/photos/1374651/pexels-photo-1374651.jpeg',
          seasonality: 'April - November'
        },
        {
          name: 'Citrus',
          description: 'Juicy oranges, lemons, and grapefruits. Mediterranean flavor at its finest.',
          image: 'https://images.pexels.com/photos/2611810/pexels-photo-2611810.jpeg',
          seasonality: 'November - May'
        }
      ]
    },
    // Packaging
    packaging: {
      title: 'Packaging & Branding',
      subtitle: 'Your Brand, Our Expertise',
      description: 'Custom packaging solutions designed for European retail and wholesale markets. From branded crates to retail-ready formats, we ensure your produce arrives shelf-ready.',
      features: [
        'Custom branded boxes and labels',
        'Retail-ready packaging formats',
        'Sustainable packaging options',
        'Bulk export crates (wood/cardboard)'
      ]
    },
    // Logistics
    logistics: {
      title: 'Logistics & Process',
      subtitle: 'From Farm to Market',
      steps: [
        {
          step: '01',
          title: 'Sourcing',
          description: 'Partner farms across Turkey prime agricultural regions'
        },
        {
          step: '02',
          title: 'Quality Control',
          description: 'Multi-stage inspection and grading by certified specialists'
        },
        {
          step: '03',
          title: 'Packing',
          description: 'Custom packaging in climate-controlled facilities'
        },
        {
          step: '04',
          title: 'Delivery',
          description: 'Cold-chain transport to Poland and across Europe'
        }
      ],
      route: {
        from: 'Turkey',
        via: 'Poland',
        to: 'Europe'
      }
    },
    // Certifications
    certifications: {
      title: 'Certifications & Compliance',
      subtitle: 'Meeting European Standards',
      items: [
        'GlobalGAP Certified',
        'EU Food Safety Standards',
        'Organic Options Available',
        'ISO 22000 Quality Management'
      ]
    },
    // Testimonials
    testimonials: {
      title: 'Trusted by Buyers Across Europe',
      items: [
        {
          quote: 'Consistent quality and reliable delivery. Lamazi Group has become our go-to supplier for fresh produce.',
          author: 'Fresh Market Poland',
          role: 'Procurement Director'
        },
        {
          quote: 'Their cold-chain logistics ensure our shelves stay stocked with the freshest produce from Turkey.',
          author: 'Euro Retail Group',
          role: 'Supply Chain Manager'
        }
      ]
    },
    // Contact/RFQ
    contact: {
      title: 'Request a Quote',
      subtitle: 'Get in touch for pricing, samples, or partnership inquiries',
      form: {
        name: 'Full Name',
        company: 'Company Name',
        email: 'Email Address',
        phone: 'Phone Number',
        product: 'Products of Interest',
        volume: 'Estimated Volume',
        message: 'Message',
        submit: 'Send Request'
      },
      whatsapp: 'WhatsApp Us',
      info: {
        title: 'Lamazi Group',
        address: 'Turkey',
        email: 'info@lamazigrup.com',
        phone: '+48 888 500 885'
      }
    },
    // Instagram
    instagram: {
      title: 'Follow Us on Instagram',
      subtitle: '@lamazigrup',
      cta: 'View on Instagram'
    },
    // Footer
    footer: {
      tagline: 'Premium fresh produce from Turkey to Europe',
      links: {
        about: 'About Us',
        products: 'Products',
        packaging: 'Packaging',
        logistics: 'Logistics',
        contact: 'Contact'
      },
      copyright: '© 2025 Lamazi Group. All rights reserved.'
    }
  },
  tr: {
    // Navigation
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      products: 'Ürünler',
      packaging: 'Paketleme',
      logistics: 'Lojistik',
      contact: 'İletişim',
      whatsapp: 'WhatsApp'
    },
    // Hero Section
    hero: {
      headline: 'İhracat kalitesinde taze ürün. Güvenle teslim.',
      subheadline: 'Lamazi Group, Türkiye\'den Avrupa\'ya premium meyve ve sebze tedarik ediyor—kalite kontrol, esnek paketleme ve soğuk zincir lojistiği.',
      cta1: 'Teklif Al',
      cta2: 'Ürünleri Gör'
    },
    // Why Lamazi
    why: {
      title: 'Neden Lamazi Group',
      subtitle: 'İlk Günden Beri İhracat Mükemmelliği',
      features: [
        {
          title: 'Kalite Kontrol',
          description: 'Tarladan son paketlemeye kadar her aşamada titiz denetim—yalnızca ihracat kalitesindeki ürünler alıcılarınıza ulaşır.'
        },
        {
          title: 'Soğuk Zincir Bütünlüğü',
          description: 'Gelişmiş sıcaklık kontrollü lojistik, Türkiye çiftliklerinden Avrupa depolarına tazeliği korur.'
        },
        {
          title: 'Güvenilir Tedarik',
          description: 'Yıl boyunca mevcudiyet ve esnek hacimler—mevsimsel talep ve uzun vadeli sözleşmelere güvenle yanıt.'
        },
        {
          title: 'Özel Paketleme',
          description: 'Markanızla özelleştirilmiş paketleme çözümleri—toplu kasalardan perakende hazır formatlara kadar.'
        }
      ]
    },
    // Products
    products: {
      title: 'Premium Taze Ürünler',
      subtitle: 'Türkiye\'den İhracat Kalitesi',
      categories: [
        {
          name: 'Domates',
          description: 'Asma olgunlaştırılmış, sert çeşitler perakende ve yemek servisi için ideal. Yıl boyunca mevcut.',
          image: 'https://images.pexels.com/photos/1327838/pexels-photo-1327838.jpeg',
          seasonality: 'Yıl boyunca'
        },
        {
          name: 'Salatalık',
          description: 'Çıtır, taze salatalıklar perakende dağıtımı için mükemmel. Sera ve tarla çeşitleri.',
          image: 'https://images.unsplash.com/photo-1587411768638-ec71f8e33b78',
          seasonality: 'Yıl boyunca'
        },
        {
          name: 'Biber',
          description: 'Renkli, tatlı biberler kırmızı, sarı ve yeşil renklerde. Avrupa pazarları için premium kalite.',
          image: 'https://images.pexels.com/photos/1374651/pexels-photo-1374651.jpeg',
          seasonality: 'Nisan - Kasım'
        },
        {
          name: 'Narenciye',
          description: 'Sulu portakallar, limonlar ve greyfurtlar. Akdeniz lezzeti en iyisiyle.',
          image: 'https://images.pexels.com/photos/2611810/pexels-photo-2611810.jpeg',
          seasonality: 'Kasım - Mayıs'
        }
      ]
    },
    // Packaging
    packaging: {
      title: 'Paketleme & Markalama',
      subtitle: 'Sizin Markanız, Bizim Uzmanlığımız',
      description: 'Avrupa perakende ve toptan pazarları için tasarlanmış özel paketleme çözümleri. Markalı kasalardan perakende hazır formatlara kadar, ürünlerinizin rafa hazır şekilde ulaşmasını sağlıyoruz.',
      features: [
        'Özel markalı kutular ve etiketler',
        'Perakende hazır paketleme formatları',
        'Sürdürülebilir paketleme seçenekleri',
        'Toplu ihracat kasaları (ahşap/karton)'
      ]
    },
    // Logistics
    logistics: {
      title: 'Lojistik & Süreç',
      subtitle: 'Çiftlikten Pazara',
      steps: [
        {
          step: '01',
          title: 'Tedarik',
          description: 'Türkiye\'nin önde gelen tarım bölgelerindeki ortak çiftlikler'
        },
        {
          step: '02',
          title: 'Kalite Kontrol',
          description: 'Sertifikalı uzmanlar tarafından çok aşamalı denetim ve derecelendirme'
        },
        {
          step: '03',
          title: 'Paketleme',
          description: 'İklim kontrollü tesislerde özel paketleme'
        },
        {
          step: '04',
          title: 'Teslimat',
          description: 'Polonya ve Avrupa genelinde soğuk zincir nakliye'
        }
      ],
      route: {
        from: 'Türkiye',
        via: 'Polonya',
        to: 'Avrupa'
      }
    },
    // Certifications
    certifications: {
      title: 'Sertifikalar & Uyumluluk',
      subtitle: 'Avrupa Standartlarını Karşılama',
      items: [
        'GlobalGAP Sertifikalı',
        'AB Gıda Güvenliği Standartları',
        'Organik Seçenekler Mevcut',
        'ISO 22000 Kalite Yönetimi'
      ]
    },
    // Testimonials
    testimonials: {
      title: 'Avrupa Genelinde Alıcılar Tarafından Güvenilen',
      items: [
        {
          quote: 'Tutarlı kalite ve güvenilir teslimat. Lamazi Group, taze ürün tedarikçimiz oldu.',
          author: 'Fresh Market Poland',
          role: 'Satın Alma Müdürü'
        },
        {
          quote: 'Soğuk zincir lojistikleri, raflarımızın Türkiye\'den en taze ürünlerle dolu kalmasını sağlıyor.',
          author: 'Euro Retail Group',
          role: 'Tedarik Zinciri Müdürü'
        }
      ]
    },
    // Contact/RFQ
    contact: {
      title: 'Teklif İste',
      subtitle: 'Fiyatlandırma, numuneler veya ortaklık soruşturmaları için iletişime geçin',
      form: {
        name: 'Ad Soyad',
        company: 'Şirket Adı',
        email: 'E-posta Adresi',
        phone: 'Telefon Numarası',
        product: 'İlgilenilen Ürünler',
        volume: 'Tahmini Hacim',
        message: 'Mesaj',
        submit: 'Talep Gönder'
      },
      whatsapp: 'WhatsApp ile İletişim',
      info: {
        title: 'Lamazi Group',
        address: 'Türkiye',
        email: 'info@lamazigrup.com',
        phone: '+48 888 500 885'
      }
    },
    // Instagram
    instagram: {
      title: 'Instagram\'da Bizi Takip Edin',
      subtitle: '@lamazigrup',
      cta: 'Instagram\'da Görüntüle'
    },
    // Footer
    footer: {
      tagline: 'Türkiye\'den Avrupa\'ya premium taze ürünler',
      links: {
        about: 'Hakkımızda',
        products: 'Ürünler',
        packaging: 'Paketleme',
        logistics: 'Lojistik',
        contact: 'İletişim'
      },
      copyright: '© 2025 Lamazi Group. Tüm hakları saklıdır.'
    }
  },
  pl: {
    // Navigation
    nav: {
      home: 'Strona Główna',
      about: 'O Nas',
      products: 'Produkty',
      packaging: 'Opakowanie',
      logistics: 'Logistyka',
      contact: 'Kontakt',
      whatsapp: 'WhatsApp'
    },
    // Hero Section
    hero: {
      headline: 'Świeże produkty klasy eksportowej, dostarczone z przekonaniem.',
      subheadline: 'Lamazi Group dostarcza premium owoce i warzywa z Turcji do kupujących w całej Europie—kontrola jakości, elastyczne opakowanie i logistyka łańcucha chłodniczego.',
      cta1: 'Poproś o Ofertę',
      cta2: 'Zobacz Produkty'
    },
    // Why Lamazi
    why: {
      title: 'Dlaczego Lamazi Group',
      subtitle: 'Doskonałość Eksportowa Od Pierwszego Dnia',
      features: [
        {
          title: 'Kontrola Jakości',
          description: 'Rygorystyczna inspekcja na każdym etapie—od pola do końcowego opakowania—zapewniając, że tylko produkty klasy eksportowej docierają do Twoich kupujących.'
        },
        {
          title: 'Integralność Łańcucha Chłodniczego',
          description: 'Zaawansowana logistyka kontrolowana temperaturą zachowuje świeżość od farm w Turcji do magazynów europejskich.'
        },
        {
          title: 'Niezawodna Dostawa',
          description: 'Dostępność przez cały rok z elastycznymi wolumenami—spełnianie sezonowego popytu i długoterminowych kontraktów z pewnością.'
        },
        {
          title: 'Niestandardowe Opakowanie',
          description: 'Dostosowane rozwiązania opakowaniowe z Twoim brandingiem—od skrzyń zbiorczych po formaty gotowe do sprzedaży detalicznej.'
        }
      ]
    },
    // Products
    products: {
      title: 'Premium Świeże Produkty',
      subtitle: 'Jakość Klasy Eksportowej z Turcji',
      categories: [
        {
          name: 'Pomidory',
          description: 'Dojrzałe na krzewie, twarde odmiany idealne dla sprzedaży detalicznej i gastronomii. Dostępne przez cały rok.',
          image: 'https://images.pexels.com/photos/1327838/pexels-photo-1327838.jpeg',
          seasonality: 'Cały rok'
        },
        {
          name: 'Ogórki',
          description: 'Chrupiące, świeże ogórki idealne do dystrybucji detalicznej. Odmiany szklarniowe i polowe.',
          image: 'https://images.unsplash.com/photo-1587411768638-ec71f8e33b78',
          seasonality: 'Cały rok'
        },
        {
          name: 'Papryka',
          description: 'Kolorowa, słodka papryka w kolorach czerwonym, żółtym i zielonym. Najwyższa jakość dla rynków europejskich.',
          image: 'https://images.pexels.com/photos/1374651/pexels-photo-1374651.jpeg',
          seasonality: 'Kwiecień - Listopad'
        },
        {
          name: 'Cytrusy',
          description: 'Soczyste pomarańcze, cytryny i grejpfruty. Śródziemnomorski smak w najlepszym wydaniu.',
          image: 'https://images.pexels.com/photos/2611810/pexels-photo-2611810.jpeg',
          seasonality: 'Listopad - Maj'
        }
      ]
    },
    // Packaging
    packaging: {
      title: 'Opakowanie i Branding',
      subtitle: 'Twoja Marka, Nasza Ekspertyza',
      description: 'Niestandardowe rozwiązania opakowaniowe zaprojektowane dla europejskich rynków detalicznych i hurtowych. Od markowanych skrzyń po formaty gotowe do sprzedaży detalicznej, zapewniamy, że Twoje produkty docierają gotowe do półki.',
      features: [
        'Niestandardowe markowane pudełka i etykiety',
        'Formaty opakowań gotowych do sprzedaży detalicznej',
        'Zrównoważone opcje opakowań',
        'Skrzynie eksportowe zbiorcze (drewno/karton)'
      ]
    },
    // Logistics
    logistics: {
      title: 'Logistyka i Proces',
      subtitle: 'Od Farmy do Rynku',
      steps: [
        {
          step: '01',
          title: 'Zaopatrzenie',
          description: 'Partnerskie farmy w najlepszych regionach rolniczych Turcji'
        },
        {
          step: '02',
          title: 'Kontrola Jakości',
          description: 'Wieloetapowa inspekcja i klasyfikacja przez certyfikowanych specjalistów'
        },
        {
          step: '03',
          title: 'Pakowanie',
          description: 'Niestandardowe opakowanie w obiektach kontrolowanych klimatycznie'
        },
        {
          step: '04',
          title: 'Dostawa',
          description: 'Transport łańcucha chłodniczego do Polski i całej Europy'
        }
      ],
      route: {
        from: 'Turcja',
        via: 'Polska',
        to: 'Europa'
      }
    },
    // Certifications
    certifications: {
      title: 'Certyfikaty i Zgodność',
      subtitle: 'Spełnianie Standardów Europejskich',
      items: [
        'Certyfikat GlobalGAP',
        'Standardy Bezpieczeństwa Żywności UE',
        'Dostępne Opcje Organiczne',
        'Zarządzanie Jakością ISO 22000'
      ]
    },
    // Testimonials
    testimonials: {
      title: 'Zaufali Nam Kupujący w Całej Europie',
      items: [
        {
          quote: 'Konsekwentna jakość i niezawodna dostawa. Lamazi Group stała się naszym głównym dostawcą świeżych produktów.',
          author: 'Fresh Market Poland',
          role: 'Dyrektor Ds. Zakupów'
        },
        {
          quote: 'Ich logistyka łańcucha chłodniczego zapewnia, że nasze półki pozostają zaopatrzone w najświeższe produkty z Turcji.',
          author: 'Euro Retail Group',
          role: 'Menedżer Łańcucha Dostaw'
        }
      ]
    },
    // Contact/RFQ
    contact: {
      title: 'Poproś o Ofertę',
      subtitle: 'Skontaktuj się w sprawie cen, próbek lub zapytań partnerskich',
      form: {
        name: 'Pełne Imię i Nazwisko',
        company: 'Nazwa Firmy',
        email: 'Adres E-mail',
        phone: 'Numer Telefonu',
        product: 'Zainteresowane Produkty',
        volume: 'Szacunkowy Wolumen',
        message: 'Wiadomość',
        submit: 'Wyślij Zapytanie'
      },
      whatsapp: 'Skontaktuj się przez WhatsApp',
      info: {
        title: 'Lamazi Group',
        address: 'Turcja',
        email: 'info@lamazigrup.com',
        phone: '+48 888 500 885'
      }
    },
    // Instagram
    instagram: {
      title: 'Śledź Nas na Instagramie',
      subtitle: '@lamazigrup',
      cta: 'Zobacz na Instagramie'
    },
    // Footer
    footer: {
      tagline: 'Premium świeże produkty z Turcji do Europy',
      links: {
        about: 'O Nas',
        products: 'Produkty',
        packaging: 'Opakowanie',
        logistics: 'Logistyka',
        contact: 'Kontakt'
      },
      copyright: '© 2025 Lamazi Group. Wszelkie prawa zastrzeżone.'
    }
  }
};
